function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import TagsFieldsConfig from "segments/desktop/core-components/tag/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";
import { TRANSPARENT_COLOR_NAME } from "styles/color-consts";
import { newBrandColors } from "constants/color-picker-constants";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Tags Grid",
    fields: _object_spread_props(_object_spread({}, ThemeConfig), {
        gridTagsBackgroundColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Tags background color",
            possibleColors: [
                ...newBrandColors,
                TRANSPARENT_COLOR_NAME
            ]
        },
        gridTagsImageHeight: {
            type: FIELD_TYPES.TEXT,
            label: "Tag images height"
        },
        gridTags: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tag",
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: _object_spread({}, TagsFieldsConfig)
            }
        }
    })
};
